import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OpenEditionsNotify({ dark = false }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await axios.post(`${API}/newsletter`, { email, list: "open-editions-gelato" });
      toast.success("You're on the list. Open editions land in your inbox first.");
      setEmail("");
      setSent(true);
    } catch {
      toast.error("Couldn't subscribe. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  const soft = dark ? "text-background/60" : "text-[hsl(var(--ink-soft))]";

  if (sent) {
    return (
      <div data-testid="open-editions-sent">
        <p className="label mb-2">On the list</p>
        <p className={`serif italic text-xl ${soft}`}>
          First look, first order. Watch your inbox.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="open-editions-form">
      <div className={`flex border-b pb-2 ${dark ? "border-background/40" : "border-border"}`}>
        <Mail className="h-5 w-5 self-center mr-3 opacity-60" />
        <input
          type="email"
          required
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={`flex-1 bg-transparent outline-none text-base py-3 ${
            dark ? "placeholder:text-background/40" : "placeholder:text-[hsl(var(--ink-soft))]/50"
          }`}
          data-testid="open-editions-email-input"
        />
        <button
          type="submit"
          disabled={busy}
          className={`inline-flex items-center gap-2 label ${dark ? "!text-background" : ""}`}
          data-testid="open-editions-submit"
        >
          {busy ? "..." : "Notify me"}
          <ArrowUpRight className="h-3.5 w-3.5" />
        </button>
      </div>
      <p className={`text-xs mt-3 ${soft}`}>
        One email when open editions go live. No spam. Never shared.
      </p>
    </form>
  );
}
